import React from 'react';
import PropTypes from 'prop-types';
import {Flex, Heading, Button} from '@spothero/ui';
import {PROPTYPE_RESERVATION} from '@/proptypes/reservation-prop-types';
import useConfig from 'hooks/use-config';
import {rightColumnItemStyleProps} from 'pages/parking-pass/styles';
import FacilityUtils from 'utils/facility-utils';
import ReservationUtils from 'utils/reservation-utils';
import trackChangeReservationClicked from 'segment/events/change-reservation-clicked';

const ChangeReservation = ({reservation, activeStatus, onTrackedClick}) => {
    const {siteUrl} = useConfig();

    if (
        (reservation.partner &&
            reservation.partner?.updateTimesEnabled === false) ||
        reservation.paymentStatus ===
            ReservationUtils.PAYMENT_STATUSES.REFUND ||
        activeStatus === ReservationUtils.ACTIVE_STATUS.ENDED ||
        (activeStatus === ReservationUtils.ACTIVE_STATUS.ACTIVE &&
            !reservation.canUpdateStartsAndEnds) ||
        (!reservation.canUpdateStartsAndEnds &&
            reservation.cancellationAllowed ===
                FacilityUtils.CANCELLATION_ALLOWED_ENUM.NOT_ALLOWED)
    ) {
        return null;
    }

    const handleClick = () => {
        trackChangeReservationClicked({reservation});

        onTrackedClick({
            clickTarget: 'Change Reservation',
            isReservationChange: true,
        });
    };

    const editLink = `${siteUrl}/account-reservations#current-${reservation.rentalId}-change`;

    return (
        <Flex
            sx={{
                '@media print': {
                    display: 'none',
                },
            }}
            backgroundColor="gray.light"
            {...rightColumnItemStyleProps}
        >
            <Heading marginBottom={3} fontSize="base" as="h3">
                Change of Plans?
            </Heading>
            <Button
                onClick={handleClick}
                href={editLink}
                cursor="pointer"
                variant="secondary"
                as="a"
            >
                Change Reservation
            </Button>
        </Flex>
    );
};

ChangeReservation.propTypes = {
    reservation: PROPTYPE_RESERVATION.isRequired,
    activeStatus: PropTypes.oneOf(
        Object.values(ReservationUtils.ACTIVE_STATUS)
    ),
    onTrackedClick: PropTypes.func.isRequired,
};

export default ChangeReservation;
